import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { IErrorResponseSchema } from 'shared/repositories/price-estimator/entities/schemas/ErrorResponseSchema';
import { validateAddress } from 'shared/thunks';
import { EStatus, TAdressState } from 'shared/types/form';

const initialState: TAdressState = {
  status: EStatus.Initial,
  errorMessage: undefined,
};

const addressSlice = createSlice({
  extraReducers(builder) {
    builder
      .addCase(validateAddress.rejected, (state, action) => {
        state.status = EStatus.Failed;
        state.errorMessage = action.payload as string;
      })
      .addCase(validateAddress.pending, state => {
        state.status = EStatus.Loading;
      })
      .addCase(validateAddress.fulfilled, state => {
        state.status = EStatus.Succeed;
        state.errorMessage = undefined;
      });
  },
  initialState,
  name: 'adress',
  reducers: {
    setErrorMessage: (state, action: PayloadAction<string | undefined>) => {
      state.errorMessage = action.payload;
    },
  },
});

export const {
  reducer: adressReducer,
  actions: { setErrorMessage },
} = addressSlice;
